<template>
    <div class="torvandom-footer">
        <!-- <img src="../assets/images/police.png" alt=""> -->
        <span></span>
        <!-- <span>京公网安备 11010802020548号</span> -->
        <!-- <span>TORVANDOM (Beijing) Technology Co., Ltd</span> -->
        <span>{{text}}</span>
    </div>
</template>

<script>
export default {
    data () {
        return {
            text: '拓万牧（北京）科技有限公司© Copyright @2020 京ICP备20019048号-1'
        }
    },
    methods: {
        switchLang (lng) {
            lng = lng || 'zh-CN'
            const data = {
                'en': 'TORVANDOM (Beijing) Technology Co., Ltd© Copyright @2020 京ICP备20019048号-1',
                'zh-CN': '拓万牧（北京）科技有限公司© Copyright @2020 京ICP备20019048号-1'
            }
            this.text = data[lng]
        }
    },
    computed: {

    }
}
</script>

<style scoped lang="less">
    .torvandom-footer{
        position: relative;
        width: 100%;
        height: 54px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        padding: 17.5px 0px;
        padding-left: 137px;
        background-color: #3E3E3E;
        font-size: 0;
        img{
            height: 19px;
            float: left;
        }
        span{
            display: block;
            float: left;
            width: 46%;
            height: 19px;
            line-height: 19px;
            font-size: 14px;
            color: #FFFFFF;
            padding-left: 6px;
            box-sizing: border-box;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            -o-box-sizing: border-box;
            -ms-box-sizing: border-box;
            &:nth-child(2){
                text-align: right;
            }
            &::nth-child(3){
                text-align: left
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue